<template>
  <div
    @click="hanldeClickContent"
  >
    <div
      :class="{dark: $vuetify.theme.dark}"
      class="contentWrap ql-editor"
      v-html="coverContent(content)"
    />
  </div>
</template>
<script>
export default {
  name: 'HtmlViwer',
  props: {
    content: String,
  },
  methods: {
    hanldeClickContent (e) {
      const el = e.target.closest('a')
      if (el && el.tagName === 'A') {
        const href = el.getAttribute('href')
        const fnMatch = href.match(/fn-(\w+)/)
        if (fnMatch) {
          const fn = fnMatch[1]
          if (fn === 'couponrelReceiveXm') {
            // this.$store.dispatch('coupon/couponrel/receiveXm').then(res => {
            //   if (!res.data.error) {
            //     this.$toast('領取成功')
            //   }
            // })
          }
          if (fn === 'applyThirdPartyJy') {
            // javascript:fn-applyThirdPartyJy
            this.$eventBus.$emit(this.$eventType.OpenCommentDetailDialog, {
              from: 'applyThirdPartyJy',
            })
          }
          e.preventDefault()
          return
        }
        const postMatch = href.match(/^post-(\d+)/)
        if (postMatch) {
          this.$store.dispatch('viewPost', postMatch[1])
        } else if (href[0] === '#') {
          this.$router.push({
            path: href.slice(1),
          })
        } else {
          window.open(href)
        }

        e.preventDefault()
      }
    },
    coverContent (html) {
      // const html = `
      //   <p>停權日期：xx</p>
      //   <p>會員編號：x</p>
      //   <p>會員暱稱：xxx</p>
      //   <p>停權方式：xxx</p>
      //   <p>申報人：xxx</p>
      //   <p>手機門號：xx</p>
      //   <p>停權原因：xx</p>
      //   <p>事發經過：</p>
      //   <p>111</p>
      //   <p>2222</p>
      //   <p>3333</p>
      //   <p>照片佐證：</p>
      //   <p>9999</p>
      //   <p>888</p>
      //   <p>7777</p>
      // `
      if (!html || html.indexOf('停權日期：') === -1) {
        return html
      }

      const parser = new DOMParser()
      const parsedDocument = parser.parseFromString(html, 'text/html')

      let content = ''
      const m = {
        停權日期: '',
        會員編號: '',
        會員暱稱: '',
        停權方式: '',
        申報人: '',
        手機門號: '',
        停權原因: '',
        事發經過: '',
        照片佐證: '',
      }
      let tempKey = '事發經過'
      parsedDocument.querySelectorAll('body>*').forEach((el) => {
        if (el.tagName !== 'P') {
          content += el.outerHTML
        } else {
          if (el.innerText.indexOf('停權日期：') === 0) {
            content += '$停權內容$'
          }
          const key = Object.keys(m).find(key => {
            return el.innerText.indexOf(key) === 0
          })
          if (key) {
            m[key] = el.innerText.replace(key + '：', '').trim()
            tempKey = key
          } else if (tempKey) {
            m[tempKey] += el.outerHTML
          } else {
            content += el.outerHTML
          }
        }
      })
      const tableHtml = `<table class="suspendPostTable">
        <tr>
          <th>停權日期</th>
          <th>會員編號</th>
          <th>會員暱稱</th>
        </tr>
        <tr>
          <td>${m.停權日期}</td>
          <td>${m.會員編號}</td>
          <td>${m.會員暱稱}</td>
        </tr>
        <tr>
          <th>停權方式</th>
          <th>申報人</th>
          <th>手機門號</th>
        </tr>
        <tr>
          <td>${m.停權方式}</td>
          <td>${m.申報人}</td>
          <td>${m.手機門號}</td>
        </tr>
        <tr>
          <th colspan="3">停權原因</th>
        </tr>
        <tr>
          <td colspan="3">${m.停權原因}</td>
        </tr>
        ${m.事發經過
? `
        <tr>
          <th colspan="3">事發經過</th>
        </tr>
        <tr>
          <td colspan="3" style="text-align: left;">${m.事發經過}</td>
        </tr>
        `
: ''}
        ${m.照片佐證
? `
        <tr>
          <th colspan="3">照片佐證</th>
        </tr>
        <tr>
          <td colspan="3">${m.照片佐證}</td>
        </tr>
        `
: ''}
      </table>`

      content = content.replace('$停權內容$', tableHtml)
      return content
    },
  },
}
</script>
<style lang="postcss">
.contentWrap.dark {
  * {
    color: inherit !important;
    background: inherit !important;
  }
}
.contentWrap.ql-editor {
  overflow: visible;
  img {
    max-width: 100%;
  }
}
.suspendPostTable {
  width: 100%;
  border: 0;
  border-collapse: collapse;
  text-align: center;
  line-height: 1.2;
  th,
  td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 6px 5px;
  }
  th {
    background: #444444;
    color: #fff;
  }
}
</style>
